import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { AdminSidebarComponent } from '../../sidebar/admin-sidebar.component';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';
import { UserComputeRequestsComponent } from '../user-compute-requests/user-compute-requests.component';
import { UserCreditRequestsComponent } from '../user-credit-requests/user-credit-requests.component';

type TabKey = 'compute-requests' | 'credit-requests';

interface Tab {
  key: TabKey;
  label: string;
}

@Component({
  selector: 'app-compute-credit-home',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    AdminSidebarComponent,
    PageHeaderComponent,
    UserComputeRequestsComponent,
    UserCreditRequestsComponent,
  ],
  templateUrl: './compute-credit-home.component.html',
  styleUrl: './compute-credit-home.component.scss',
})
export class ComputeCreditHomeComponent implements OnInit, AfterViewInit {
  @ViewChild('userCreditRequests') userCreditRequestsComponent!: UserCreditRequestsComponent;
  @ViewChild('userComputeRequests') userComputeRequestsComponent!: UserComputeRequestsComponent;

  activeTab: TabKey = 'compute-requests';

  tabs: Tab[] = [
    {
      key: 'compute-requests',
      label: 'Compute Role Requests',
    },
    {
      key: 'credit-requests',
      label: 'Credit Requests',
    },
  ];

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // Load data for the default tab
    setTimeout(() => {
      if (this.activeTab === 'credit-requests') {
        this.loadCreditRequests();
      } else if (this.activeTab === 'compute-requests') {
        this.loadComputeRequests();
      }
    }, 100);
  }

  setActiveTab(tabKey: TabKey): void {
    this.activeTab = tabKey;
    
    // When switching tabs, load the appropriate data
    setTimeout(() => {
      if (tabKey === 'credit-requests') {
        this.loadCreditRequests();
      } else if (tabKey === 'compute-requests') {
        this.loadComputeRequests();
      }
    }, 100);
  }

  private loadCreditRequests(): void {
    if (this.userCreditRequestsComponent) {
      this.userCreditRequestsComponent.loadCreditRequests();
    }
  }

  private loadComputeRequests(): void {
    if (this.userComputeRequestsComponent) {
      this.userComputeRequestsComponent.loadComputeRequests();
    }
  }
}
